import { useQuery, useMutation, useQueryClient } from 'react-query'
import client, { multipartclient, deleteclient } from './api-client';
import { find } from 'lodash';

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

async function insertNote(data) {
    await client("notes", { body: data })
}

export function useInsertNote() {
    const queryClient = useQueryClient()

    return useMutation(insertNote, {
        // Notice the second argument is the variables object that the `mutate` function receives
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries('notes')
        },
    })
}

async function fetchNotes(parcel_id, user) {
    const data = await client(`notes/?parcel=${parcel_id}&client_id=${user.id}`)
    return data
}

export function useParcelNotes(parcel_id, user) {
    return useQuery(['notes', parcel_id, user.id], () => fetchNotes(parcel_id, user), {
        enabled: false,
        refetchAllOnWindowFocus: false,
        ...queryConfig
    });
}




const getSignedUrl = async (file) => {

    setFetching(true)
    try {
        const get = await mutate({ variables: { email: currentUser.email, fileName: file[0].name, } })
        if (get.data?.s3PostUrl.success) {
            const { payload } = get.data.s3PostUrl
            payload.fields.file = file[0]
            uploadToS3(payload)
        }
    } catch (error) {
        setError(error)
    }
};

const uploadToS3 = async (payload) => {
    const { url, fields } = payload
    const formData = new FormData();
    Object.keys(fields).forEach(key => {
        formData.append(key, fields[key]);
    });

    const data = await fetch(url, { method: "POST", body: formData })
        .then((res) => {
            if (res.ok) {
                return res.json()
            }
        })
        .catch((error) => {
            console.error(error)
        })
}


async function addNote(noteData) {
    if (noteData.attachments.length > 0) {
        const urls = await client(`notes/urls_for_post/`, { body: { files: noteData.attachments.map((element, index) => element.name) } })

        urls.map(payload => {
            const file = find(noteData.attachments, (el) => el.name === payload.original_name)
            return {
                ...payload, fields:
                    { ...payload.fields, file }
            }
        }
        ).map(payload => {
            uploadToS3(payload)
        })

        noteData.attachments = urls.map(payload => payload.fields.key);
    }

    const data = await client('notes/', { body: noteData });
    return data;
}

export function useAddNoteMutation() {
    const queryClient = useQueryClient();

    return useMutation((noteData) => addNote(noteData), {
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries(['notes', variables.parcel])
        },
    });
}

async function deleteNote(note, user) {
    await deleteclient(`notes/${note.id}/?client_id=${user.id}`)
}

export function useDeleteNoteMutation() {
    return useMutation(({ note, user }) => deleteNote(note, user));
}
